import React from 'react';

export const Pdf = props => (
  <svg
    width="36"
    height="38"
    viewBox="0 0 36 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_dd_2613_7909)">
      <rect
        x="1.59961"
        y="0.800049"
        width="32"
        height="32"
        rx="8"
        fill="url(#paint0_linear_2613_7909)"
      />
      <rect
        x="1.99961"
        y="1.20005"
        width="31.2"
        height="31.2"
        rx="7.6"
        stroke="white"
        strokeWidth="0.8"
      />
      <path
        d="M5.75879 16.4004H29.4395C29.894 16.4004 30.2113 16.4007 30.458 16.4209C30.6998 16.4407 30.8391 16.4776 30.9443 16.5312C31.1699 16.6463 31.3538 16.83 31.4688 17.0557C31.5223 17.1609 31.5594 17.3003 31.5791 17.542C31.5992 17.7886 31.5996 18.1054 31.5996 18.5596V20.96C31.5996 22.7587 31.5992 24.0837 31.5137 25.1309C31.4285 26.1733 31.2606 26.9057 30.9453 27.5244C30.3701 28.6532 29.4521 29.5713 28.3232 30.1465C27.7045 30.4617 26.9721 30.6287 25.9297 30.7139C24.8826 30.7994 23.5573 30.7998 21.7588 30.7998H13.4395C11.6408 30.7998 10.3157 30.7994 9.26855 30.7139C8.22608 30.6287 7.49373 30.4617 6.875 30.1465C5.74614 29.5713 4.82817 28.6532 4.25293 27.5244C3.93767 26.9057 3.77072 26.1733 3.68555 25.1309C3.59999 24.0837 3.59961 22.7587 3.59961 20.96V18.5596C3.59961 18.1053 3.59999 17.7886 3.62012 17.542C3.63988 17.3001 3.67684 17.161 3.73047 17.0557C3.84552 16.8299 4.02909 16.6463 4.25488 16.5312C4.3602 16.4776 4.49928 16.4407 4.74121 16.4209C4.98783 16.4008 5.30454 16.4004 5.75879 16.4004Z"
        fill="url(#paint1_linear_2613_7909)"
        stroke="#BE2929"
        strokeWidth="0.8"
      />
      <path
        d="M3.19922 12.64C3.19922 13.536 3.19922 13.9841 3.37361 14.3263C3.52701 14.6274 3.77177 14.8722 4.07283 15.0256C4.41509 15.2 4.86313 15.2 5.75922 15.2H29.4392C30.3353 15.2 30.7833 15.2 31.1256 15.0256C31.4267 14.8722 31.6714 14.6274 31.8248 14.3263C31.9992 13.9841 31.9992 13.536 31.9992 12.64C31.9992 9.05562 31.9992 7.26345 31.3017 5.89441C30.6881 4.69018 29.709 3.7111 28.5048 3.09751C27.1357 2.39995 25.3436 2.39995 21.7592 2.39995H13.4392C9.85488 2.39995 8.06272 2.39995 6.69368 3.09751C5.48944 3.7111 4.51037 4.69018 3.89678 5.89441C3.19922 7.26345 3.19922 9.05562 3.19922 12.64Z"
        fill="url(#paint2_linear_2613_7909)"
      />
      <g filter="url(#filter1_di_2613_7909)">
        <path
          d="M9.73598 27V20.6H12.3797C12.8589 20.6 13.2724 20.6937 13.6204 20.8812C13.9704 21.0667 14.2401 21.326 14.4297 21.6594C14.6193 21.9906 14.7141 22.376 14.7141 22.8156C14.7141 23.2573 14.6172 23.6437 14.4235 23.975C14.2318 24.3042 13.9579 24.5594 13.6016 24.7406C13.2454 24.9219 12.8224 25.0125 12.3329 25.0125H10.7016V23.7937H12.0454C12.2787 23.7937 12.4735 23.7531 12.6297 23.6719C12.7881 23.5906 12.9079 23.4771 12.9891 23.3312C13.0704 23.1833 13.111 23.0115 13.111 22.8156C13.111 22.6177 13.0704 22.4469 12.9891 22.3031C12.9079 22.1573 12.7881 22.0448 12.6297 21.9656C12.4714 21.8865 12.2766 21.8469 12.0454 21.8469H11.2829V27H9.73598ZM17.7322 27H15.3666V20.6H17.7291C18.3812 20.6 18.9426 20.7281 19.4135 20.9844C19.8864 21.2385 20.251 21.6052 20.5072 22.0844C20.7635 22.5615 20.8916 23.1323 20.8916 23.7969C20.8916 24.4635 20.7635 25.0365 20.5072 25.5156C20.2531 25.9948 19.8895 26.3625 19.4166 26.6187C18.9437 26.8729 18.3822 27 17.7322 27ZM16.9135 25.6812H17.6729C18.0312 25.6812 18.3343 25.6208 18.5822 25.5C18.8322 25.3771 19.0208 25.1781 19.1479 24.9031C19.277 24.626 19.3416 24.2573 19.3416 23.7969C19.3416 23.3365 19.277 22.9698 19.1479 22.6969C19.0187 22.4219 18.8281 22.224 18.576 22.1031C18.326 21.9802 18.0176 21.9187 17.651 21.9187H16.9135V25.6812ZM21.6847 27V20.6H26.0535V21.8562H23.2316V23.1687H25.7754V24.4281H23.2316V27H21.6847Z"
          fill="url(#paint3_linear_2613_7909)"
          shapeRendering="crispEdges"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_2613_7909"
        x="-0.000390768"
        y="4.88162e-05"
        width="35.2"
        height="37.6"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="0.8"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_2613_7909"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 0 0.905882 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7909"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="3.2"
          operator="erode"
          in="SourceAlpha"
          result="effect2_dropShadow_2613_7909"
        />
        <feOffset dy="3.2" />
        <feGaussianBlur stdDeviation="2.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_2613_7909"
          result="effect2_dropShadow_2613_7909"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_2613_7909"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_di_2613_7909"
        x="9.73633"
        y="19.8001"
        width="16.3174"
        height="7.9999"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.745098 0 0 0 0 0.160784 0 0 0 0 0.160784 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2613_7909"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2613_7909"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.8" />
        <feGaussianBlur stdDeviation="0.8" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_2613_7909"
        />
      </filter>
      <linearGradient
        id="paint0_linear_2613_7909"
        x1="17.5996"
        y1="0.800049"
        x2="17.5996"
        y2="32.8"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#F1F1F1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2613_7909"
        x1="17.5992"
        y1="17.4476"
        x2="17.5992"
        y2="31.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BE2929" />
        <stop offset="1" stopColor="#DD4A4A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2613_7909"
        x1="17.5992"
        y1="2.39995"
        x2="17.5992"
        y2="15.2"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8DDDD" />
        <stop offset="1" stopColor="#F4F4F4" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2613_7909"
        x1="17.7998"
        y1="19.4667"
        x2="17.7998"
        y2="25.7"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);
